import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { browserMessages } from '../common-class/survey-messages';
import { ParticipationDataService } from './participation-data.service';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorsHandlerService implements ErrorHandler {
  constructor(private service: ParticipationDataService) {}

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      let errormessage = '';
      if (!navigator.onLine) {
        // Handle offline error
        console.log('Network Not Available');
        errormessage = 'Network Not Available';
      } else {
        // Handle Http Error (error.status === 403, 404...)

        if (error.status == 404) {
          console.log('Server Not Found');
          errormessage = 'Server Not Found';
        } else {
          console.log('Something Wrong');
          errormessage = 'Something Wrong';
        }

        let browserError: browserMessages = new browserMessages();
        browserError.componentName = 'HttpErrorResponse';
        browserError.errorMessage = errormessage;
        browserError.errorType = 'HttpErrorResponse';
        browserError.stackTrace =
          error.type + '_' + error.message + '_' + error.statusText + '_' + error.name;
        browserError.userAgent = window.navigator.userAgent;
        browserError.userUrl = window.location.href;
        browserError.ResponseUID = this.service.getRecNO();
        let url = 'PostErrorData';
        this.service
          .PostErrorData(
            url,
            JSON.stringify(
              EncryptionAndDecryption.EncryptionData(
                '123456$#@$^@1ERF',
                JSON.stringify(browserError),
              ),
            ),
          )
          .subscribe(
            async (data) => {
              console.log(data);
            },
            (error) => {},
          );
      }
    } else {
      // Handle Client Error (Angular Error, ReferenceError...)
      if (error.stack.split('\n')[0].toString().toLowerCase().indexOf('nicescroll') == -1) {
        let browserError: browserMessages = new browserMessages();
        browserError.componentName = error.stack.split('\n')[1].trim().split(' ')[1];
        browserError.errorMessage = error.message;
        browserError.errorType = error.stack.split('\n')[0];
        browserError.stackTrace = error.stack;
        browserError.userAgent = window.navigator.userAgent;
        browserError.userUrl = window.location.href;
        browserError.ResponseUID = this.service.getRecNO();
        let url = 'PostErrorData';
        this.service
          .PostErrorData(
            url,
            JSON.stringify(
              EncryptionAndDecryption.EncryptionData(
                '123456$#@$^@1ERF',
                JSON.stringify(browserError),
              ),
            ),
          )
          .subscribe(
            async (data) => {
              console.log(data);
            },
            (error) => {},
          );
      }
    }
    this.monitorWindowErrors();
    this.monitorIframeErrors();
  }
   monitorWindowErrors() {
    window.onerror = (message, source, lineno, colno, error) => {
      console.error('Main window error:', { message, source, lineno, colno, error });
      this.handleReferenceError(message as string);
      return false; // Continue default handling
    };
  }

  // Attach error listeners to all iframes on the page
  monitorIframeErrors() {
    const iframes = document.getElementsByTagName('iframe');
    for (let i = 0; i < iframes.length; i++) {
      const iframe = iframes[i];
      iframe.onload = () => {
        try {
          const iframeWindow = iframe.contentWindow;
          if (iframeWindow) {
            iframeWindow.onerror = (msg, url, line, col, err) => {
              console.error('Iframe error:', { msg, url, line, col, err });
              this.handleReferenceError(msg as string);
              return false;
            };
          }
        } catch (e) {
          console.warn('Cannot attach error handler to iframe:', e);
        }
      };
    }
  }

  // Detect ReferenceError about missing variables from the message string
  private handleReferenceError(message: string) {
    if (message.includes("Can't find variable") || message.includes("ReferenceError")) {
      const variable = this.extractVariableFromMessage(message);
      console.warn(`ReferenceError detected: variable "${variable}" is not defined`);
      // You can extend this: send to logging server, display UI notification, etc.
    }
  }

  private extractVariableFromMessage(message: string): string {
    const regex = /(?:Can't find variable|ReferenceError):?\s*['"]?(\w+)['"]?/i;
    const match = message.match(regex);
    return match ? match[1] : 'unknown';
  }
}
